import { Service } from "@front-apps/core/services/Service"
import NavigationService from "@front-apps/core/services/navigation"
import PartnerApi from "../API/partners"
import { Partner } from "../models/partners"
class PartnerService extends Service {
    private static instance: PartnerService

    constructor() {
        super()
        // set le nom du service
        this.name = "PartnerService"
        // ajoute toute les methodes du service au tableau de mapping
        this.serviceMap = [
            { key: "fetchGroupPartners", fct: this.fetchGroupPartners },
        ]
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): PartnerService {
        if (!this.instance) {
            this.instance = new PartnerService()
        }
        return this.instance
    }

    public async getPartners(group: string, pdv: string) {
        return await PartnerApi.getPartners(group, pdv)
    }

    public async fetchGroupPartners(
        groupId: any,
        partnerValue?: string,
        pdv: string = "0"
    ): Promise<any> {
        try {
            if (!groupId) {
                throw new Error("Group ID is required")
            }

            const partners: Partner[] = await this.getPartners(groupId, pdv)
            if (partnerValue) {
                return partners.filter(
                    (partner) => partner.value === partnerValue
                )
            }
            return partners.filter((partner) => partner.show)
        } catch (error) {
            console.error("Error fetching partners:", error)
            NavigationService.getInstance().navigateTo("error", {
                groupId,
            })
        }
    }
}

export default PartnerService
